export default {
  meau: {
    nav: 'Homepage',
    // nav2: 'Community',
    // nav3: 'Download',
    // nav4: 'Node Reward',
    // nav5: 'NFT',
    // nav6: 'Internet Cafe',
    // nav7: 'GameFi',

    nav1: 'Node Sale',
    nav2: 'Orion GPU Race',
    nav3: 'DeepLink Software',
    nav3_1: 'Download DeepLink',
    nav3_2: 'Software License',
    nav4: 'Bandwidth Mining',
    nav5: 'Cloud Internet Cafe',
    nav6: 'Blog',
    nav7: 'Docs',
    nav8: 'Download'
  },
  cont1: {
    text1: 'Remote Control Software Focused on Gaming',
    text2: 'Cloud Game Platform',
    btn: 'Download Now',
    btn1: 'Windows PC',
    btn2: 'WEB Remote',
    btn3: 'Android',
    btn4: 'Google Play',
    btn5: 'macOS',
    btn6: 'IOS',
    version: 'Version {ver}',
    text3_1: 'Join',
    text3_2: 'the community',
    text3_3: 'to get DeepLink Coin rewards!'
  },
  cont2: {
    text1: 'DeepLink',
    text2: 'Relying on e-sports-level low-latency technical capabilities, you can play games smoothly',
    text3: 'Core competencies and technical strengths',
    text4: 'Based on the core capabilities of cloud gaming, the experience is far superior to traditional remote control!',
    leaf1: {
      text1: 'Highly smooth, high performance',
      text2: 'Low cost',
      text3: 'Industry-leading codec solution with minimal performance consumption and resource usage at the same code rate',
      text4: 'peer-to-peer:Supports ipv6 with up to 95% NAT throughput and zero bandwidth usage.'
    },
    leaf2: {
      text1: 'High frame rate, low latency',
      text2: '',
      text3: "With LAN latency <15ms and 4K 240Hz capability, the WAN review is also in the world's top tier."
    },
    leaf3: {
      text1: 'High definition',
      text2: '',
      text3: 'Intelligent algorithms enhance viewing at the same bit rate and restore the most realistic colour performance.'
    },
    leaf4: {
      text1: 'Highly stable',
      text2: '',
      text3: 'Anti-packaging loss and anti-congestion strategies supported by large amounts of data, allowing for rapid adjustment to data packaging loss and congestion.'
    },
    leaf5: {
      text1: 'Highly secure',
      text2: '',
      text3: 'All data is encrypted by DTLS1.2 with AES256.'
    }
  },
  cont3: {
    text1: "So smooth it's like controlling a local device",
    text2: 'Applying dozens of optimisation techniques in three main areas, DeepLink is able to maintain a high frame rate despite a 5% packaging loss rate and 100ms network latency*. Meeting the requirements of all types of network environments.',
    li1: {
      text1: 'Weak network countermeasure technology',
      text2: 'FEC anti-packaging loss strategy',
      text3: 'Bandwidth Forecast',
      text4: 'SVC coding strategy'
    },
    li2: {
      text1: 'Transmission optimisation techniques',
      text2: 'Port fingerprint prediction',
      text3: 'Supports IPV6',
      text4: 'UPNP',
      text5: 'Intelligent routing'
    },
    li3: {
      text1: 'Display processing technology',
      text2: 'Frame rate adaptation strategy',
      text3: 'Motion picture prediction',
      text4: 'Jitter processing strategy',
      text5: 'AI low-coding HD rendering',
      text6: 'Dynamic virtual reality ware'
    },
    desc3: 'LAN < 5 ms - Intercity network < 10 ms - Interprovincial network < 30 ms'
  },
  cont4: {
    text1: 'Super clear graphic quality',
    text2: 'Ultra HD resolution',
    text3: '1.07 billion colours supported',
    text4: '4:4:4 undamaged picture quality',
    text5: "DeepLink always uses more demanding image quality metrics to achieve an image experience that far exceeds other traditional remote technologies, with remote image distortion below the limit of human recognition, fully supporting the creative industry's demand for precise picture display.",
    text6: '*PSNR refers to Peak Signal to Noise Ratio, below 20dB the picture distortion is high, 20-30dB the picture distortion is average, 30-40dB the picture distortion is low, above 40dB the picture distortion is extremely low and undetectable to the naked eye.'
  },
  cont5: {
    text1: 'Extensive peripheral support',
    text2: 'DeepLink provides remote support for professional accessories such as digital boards and joysticks for the creative industry, and optimises the use of creative software such as PS, Zbrush and Unity to ensure a consistent experience of creative production tools in both remote and local states.'
  },
  cont6: {
    text1: 'Multiple guarantees - minimalist approach',
    block1: {
      title1: 'Secure accounts',
      desc1: 'Multi-layer account protection mechanism for peace of mind',
      title2: 'Secure connection',
      desc2: 'DTLS1.2 protocol protection, access only with authorisation',
      title3: 'Secure data',
      desc3: '256-bit AES encryption, secure throughout transmission',
      title4: 'Secure devices',
      desc4: 'Only the corresponding person will see the corresponding device according to your settings'
    },
    block2: {
      title1: 'Multiple security guarantees',
      desc1: 'Safeguarding every connection',
      title2: 'Easy to use',
      desc2: 'Easy to start'
    },
    block3: {
      title1: 'Lightweight for downloading',
      desc1: "For DeepLink's client-end it's only about 10M",
      title2: 'Easy to learn',
      desc2: 'The configuration process can be completed by following the guidelines',
      title3: 'Easy to use',
      desc3: 'Remote control of any device within your rights via the mouse'
    }
  },
  cont7: {
    text1: 'Dedicated to offer remote control solutions',
    block1: {
      word1: 'Education industry',
      word2: 'Game industry',
      word3: 'Creative & design industry',
      word4: 'IT industry',
      word5: 'Businessmen and women on the go',
      word6: 'Co-contributors around the world',
      word7: 'IT O&M Remote Maintenance',
      word8: 'Individual users and gamers'
    },
    block2: {
      text1: 'Support for remote control scenarios in various industries',
      text2: 'Based on the actual needs of companies in various industries, we help them to achieve their business goals in an energy-efficient manner.',
      text3: 'Offers personalisation and encryption policies, flexible security',
      text4: "The company's employees are able to access the company's resources at any time and from anywhere based on their actual permissions."
    },
    block3: {
      text1: 'Covering a wide range of user needs',
      text2: 'Whether you choose to use it for your in-house staff,',
      text3: 'or for external customers, collaborators, or even personal use.',
      text4: 'Our remote control capabilities can serve you on major platforms and devices,',
      text5: 'offering an alternative, simple and clever way of solving problems.'
    }
  },
  cont9: {
    block1: {
      text1: 'Multiple security guarantees',
      text2: 'Protects your every connection',
    },
    block2: { 
      title1: 'Internet Cafes sharing',
      text1_1: '256-bit AES encryption',
      text1_2: 'The whole transmission process is kept confidential',
      title2: 'Safe connection',
      text2_1: 'DTLS1.2 protocol protection',
      text2_2: 'Authorized access only',
      title3: 'Devices secured',
      text3_1: 'According to your settings, only the corresponding user can see the corresponding equipment',
      title4: 'Account secured',
      text4_1: 'Multi-layer account protection mechanism based on blockchain technology, device information, point-to-point encrypted transmission without going through a centralized server',
    },
    block3: {
      text1: 'Internet Cafes sharing',
      text2: 'Internet cafe owners can rent out their Internet cafe machines through DeepLink to earn income, and users can play games in the Internet cafes within 50 kilometers of their homes through DeepLink without actually going to the Internet Cafe',
    },
  },
  cont10: {
    title: 'DeepLink provides Cloud game solution',
    desc: 'Maximize profit margins for Internet cafes with reduced costs and unlimited scalability',
    block1: {
      title1: '4 major problems for Internet Cafes currently',
      text1: 'Electricity bills rising again?',
      text1_1: 'Electricity bills',
      text1_2: 'rising due to government policies',
      text2: 'How many RTX-40XX can an Internet Cafe afford?',
      text2_1: 'GPU/CPU upgrading burden',
      text2_2: 'Every time a new GPU is released, it comes with the burden of expensive GPU upgrade purchases.',
      text3: 'Can we change how the consumers consume?',
      text3_1: 'Payment method',
      text3_2: 'In order to change the fixed knowledge of payment limited to 1,000 won, a reason is needed to change the status quo.',
      text4: 'How to face the impact of external environmental factors?',
      text4_1: 'Low utilization rate of PCs in Internet cafes',
      text4_2: 'Due to the pandemic, weather, etc., there are fewer users going to Internet cafes, and there is a problem of disposing of idle computers.',
    },
    block2: {
      title1: 'Cloud Internet Cafe Chain Store',
      desc1: 'The value of cloud Internet cafes: reduce start-up costs and maintenance costs, without additional upgrade costs, and provide optimal economic benefits for Internet cafe owners.',
      text1_1: 'cost reduced by 61%',
      text1_2: 'Lighten and reduce start-up costs and PC procurement costs',
      text2_1: 'Super low-latency',
      text2_2: 'Provide high-performance computing power and improve game response speed',
      text3_1: '"Zero" maintenance costs',
      text3_2: 'No desktop management costs',
      text4_1: 'Increase in turnover',
      text4_2: 'According to the GPU model, set the payment standard separately, and all seats can be set as "advanced area"',
      text5_1: 'Save on electricity bills',
      text5_2: 'Energy saving and emission reduction, carbon emission reduction',
      text4: 'How to face the impact of external environmental factors?',
      text6_1: '"Zero" maintenance costs',
      text6_2: 'GPU/CPU upgrades are done in the cloud center',
    }
  },
  footer: {
    link: 'Learn more About',
    community: 'Follow our community',
    tip: 'Our communities on: Twitter、telegram、reddit、medium、discord、tiktok、YouTube',
    text: 'DeepLink Protocol is a decentralized AI cloud gaming protocol that combines AI, GPU, and blockchain technologies to offer ultra-low latency game rendering technology. It provides cost-effective cloud gaming solutions for industries such as AAA games, cloud internet cafes, and cloud esports hotels',
    meau1: 'About',
    meau2: 'Products',
    meau3: 'Blockchain',
    meau4: 'Major Airdrop Events',
    btn5: 'Windows SDK',
    meau3_text1: 'BSC Chain DLC Browser',
    meau3_text2: 'DBC Chain DLC Browser',
    meau3_text3: 'DBC Mainnet Wallet',
    meau3_text4: 'DBC EVM Chain Browser',
    meau4_text1: 'Bybit 100,000,000 DLC Airdrop',
    meau4_text2: 'Okx 120,000,000 DLC Airdrop',
    meau4_text3: 'Binance 100,000,000 DLC Airdrop',
  },
  reward: {
    title1: 'DeepLink node(s)',
    desc1: 'Have access to rewards, e.g. DeepLink Token, Crown NFT, power of community governance.',
    title2: 'Get Genesis Node NFT',
    text1: "The more users in DeepLink's network, the more computation and traffic are needed. Genesis Nodes provide infrastructure for DeepLink network, thus decentralizing and helping DeepLink grow faster.",
    text2: 'By purchasing a Genesis Node NFT, you get the opportunity to be rewarded for your contribution to the network.',
    text3: 'This may include DeepLink Token, Crown NFT, and the power of community governance.',
    text4_1: 'Have questions? Come talk to us on',
    text4_2: 'and',
    text4_3: '',
    btntext: 'Buy now',
    text5: 'For every 1,000 Genesis Nodes NFT sold, the price increases by 1,000USD',
    text6_1: 'The number of nodes',
    text6_2: 'each NFT supports currently',
    text7: 'Total number of Genesis nodes NFT',
    text8: 'Issuance capped forever',
    text9: 'Initial price',
    text10_1: 'Maximum number of nodes',
    text10_2: 'Supported per NFT',
    text11: 'Maximum price',
    text12: 'What is a Genesis node?',
    text13: 'Genesis nodes undertake the core tasks of DeepLink network computing and traffic forwarding, and DeepLink enables more people to participate in gaining revenue through the mining model.',
    text14: 'How many Tokens in total have been given to Genesis nodes for rewards?',
    text15: '30% of the total number of tokens, i.e.30 billion DeepLink Token',
    text16: 'What is the Genesis Node NFT',
    text17: 'Only those who have Genesis Node NFT can participate in mining.',
    text18: 'How is the revenue from the sale of Genesis Node NFT distributed?',
    text19: '50% of the proceeds are invested in decentralized liquidity reward pools (e.g. DeepLink Token/USDC for Uniswap, Sushiswap) and 50% goes to DeepLink operating company as proceeds.',
    text20: 'What is the specific mining mechanism?',
    text21: 'The total reward is 5 billion a year, halved every 3 years, 10% of DeepLink Crown NFT revenue is used to buy back DeepLink Token to be added to the total reward pool before each halving, as part of the 50% reward Token, awarded to all nodes in 3 years. For example, after 3 years, 10% of DeepLink Crown NFT earnings can repurchase 12 billion DeepLink Token, then the total remaining reward pool becomes: 12 billion + 15 billion, a total of 27 billion, and the total annual reward from the second 3-years is 27 billion * 50% * 1/3 = 4.5 billion.',
    text22: 'What are the requirements for Genesis node machines?',
    text23: "Each machine must already be in DeepBrain Chain's network. DeepBrain Chain is a decentralized high-performance computing network, and the machines in DeepBrain Chain have pledged DBC, which can guarantee the stability of the machines. For more information about DeepBrain Chain:",
    text24: 'What are the other benefits of holding a Genesis Node NFT?',
    details: {
      text1: "1. Holding a certain number of Genesis Node NFTs gives you the general agency right to sell DeepLink NFTs in a country (1 NFT is needed for every 3 million people according to the country's population ratio);",
      text2: '2.DeepLink Coin airdrop;',
      text3: '3.DeepLink incubated gaming project token airdrop;',
      text4: '4. Right to vote for which games to be launched online;',
      text5: '5. Game NFT purchase discount;',
      text6: '6. Cloud game rights and hours purchase discount;',
      text7: '7. Other rights to participate in community governance.'
    },
    question: {
      text1_1: 'What is a Genesis node?',
      text1_2: 'Genesis nodes undertake the core tasks of DeepLink network computing and traffic forwarding, and DeepLink enables more people to participate in gaining revenue through the mining model.',
      text2_1: 'How many Tokens in total have been given to Genesis nodes for rewards?',
      text2_2: '10% of the total number of tokens, i.e.10 billion DeepLink Token', 
      text3_1: 'What is the Genesis Node NFT',
      text3_2: 'Only those who have Genesis Node NFT can participate in mining.',
      text4_1: 'How is the revenue from the sale of Genesis Node NFT distributed?',
      text4_2: '50% of the proceeds are invested in decentralized liquidity reward pools (e.g. DeepLink Token/USDC for Uniswap, Sushiswap) and 50% goes to DeepLink operating company as proceeds.',
      text5_1: 'What is the specific mining mechanism?',
      text5_2: 'The total reward is 5 billion a year, halved every 3 years, 10% of DeepLink Crown NFT revenue is used to buy back DeepLink Token to be added to the total reward pool before each halving, as part of the 50% reward Token, awarded to all nodes in 3 years. For example, after 3 years, 10% of DeepLink Crown NFT earnings can repurchase 12 billion DeepLink Token, then the total remaining reward pool becomes: 12 billion + 15 billion, a total of 27 billion, and the total annual reward from the second 3-years is 27 billion * 50% * 1/3 = 4.5 billion.',
      text6_1: 'What are the requirements for Genesis node machines?',
      text6_2: "Each machine must already be in DeepBrain Chain's network. DeepBrain Chain is a decentralized high-performance computing network, and the machines in DeepBrain Chain have pledged DBC, which can guarantee the stability of the machines. For more information about DeepBrain Chain:",
      text7_1: 'What are the other benefits of holding a Genesis Node NFT?',
      text7_2: `1. Holding a certain number of Genesis Node NFTs gives you the general agency right to sell DeepLink NFTs in a country (1 NFT is needed for every 3 million people according to the country's population ratio);2.DeepLink Coin airdrop;3.DeepLink incubated gaming project token airdrop;4. Right to vote for which games to be launched online;5. Game NFT purchase discount;
      6. Cloud game rights and hours purchase discount;7. Other rights to participate in community governance.`
    }
  },
  nft: {
    cont: {
      title1: 'Crown NFT',
      desc1: 'Owning this NFT grants access to premium features of DeepLink software',
      desc2: 'After purchase, the NFT remains dormant. When needed, it can be activated in DeepLink software. Once activated,',
      desc3: 'a countdown begins until expiration',
      // desc4: '40% of the proceeds are invested in the liquidity reward pool, and 50% is DeepLink operating company proceeds.',
      desc4: '40% of the proceeds will be destroyed to increase the value of the DLC Token.'
    },
    enabl: {
      title1: 'NFT Rights',
      // desc1: '1 year access to all enterprise features of DeepLink software',
      desc1: 'Grants full access to all premium features of DeepLink software',
      desc2: 'Enjoy 10% discount on cloud gaming services during NFT activation period',
      desc3: 'Potential airdrop opportunities of partner tokens',
      // desc4: 'Right to vote for which games to be launched online',
      // desc5: 'Game NFT purchase discount',
      // desc6: 'Cloud game rights and hours purchase discount',
      // desc7: 'Other rights to participate in community governance'

    },
    edition: {
      title1: 'Premium Version',
      title2: 'Enterprise Version',
      tip: 'Crown NFT',
      btn: 'Buy now',
      title3: 'Professional VS Team',
      desc: 'Specific features access',
      list: {
        li1_1: 'Content',
        li1_2: 'Basic version',
        li1_3: 'Premium Version',
        li1_4: 'Enterprise Version',
        li2_1: 'Best picture quality',
        li3_1: 'Forwarding server room',
        li3_2: 'Small amount',
        li3_3: 'Large amount',
        li4_1: 'Forwarding bandwidth',
        li4_2: 'Maximum 4M',
        li4_3: 'Maximum50M',
        li4_4: 'Unlimited',
        li5_1: 'End-to-end delay',
        li5_2: 'Minimum <40ms',
        li5_3: 'Minimum <20ms',
        li6_1:'Number of devices that can initiate remote control simultaneously',
        li7_1:'Number of devices',
        li8_1:'Remote Desktop',
        li9_1:'Remote camera',
        li10_1:'Remote SSH',
        li11_1:'Privacy Screen',
        li12_1:'Virtual monitor',
        li13_1:'Gaming keypad',
        li14_1:'Multi-streaming',
        li15_1:'444 True color',
        li16_1:'Record screenshots',
        li17_1:'Dual Screen to Dual Screen',
        li18_1:'Handle',
        li19_1:'User/Device Grouping Management',
        li20_1:'SSO Single Sign-In',
        li21_1:'Unified Management Authorization',
        li22_1:'Bulk Deployment',
        li23_1:'Employee Behavior Audit',
        li24_1:'Watermark',
        li25_1:'Price',
        li26_1: 'Single-machine desktop sessions',
        li27_1: 'File transfer',
        li28_1: 'Remote control Windows PC from Android',
        li29_1: 'Remote control Windows PC from browser',

        new_text1: 'If the same wallet address is logged in on multiple devices simultaneously, only one of the devices can initiate remote control.',
        new_text2: 'A machine can only open two remotely controlled windows',
      }
    }
  },
  internetCafe: {
    title1: 'DeepLink Cloud Internet Cafes solution',
    block1: {
      text1: 'Reduce the main hardware investment of Internet cafes by more than 60%',
      text2: '40% shorter ROI period',
      text3: 'Check video',
      text4: 'View File',
    },
    title2: 'Cloud Internet Cafes NFT price',
    block2: {
      desc: '40% of the proceeds will be invested in the DLC Coin pool of the DEX exchange to reward DLC investors',
      text1_1: 'Supports 50 machines',
      text1_2: '3600 USDT a year',
      text2_1: 'Supports 100 machines',
      text2_2: '7200 USDT a year',
      text3_1: 'Supports 150 machines',
      text3_2: '10800 USDT a year',
      text4_1: 'Supports 200 machines',
      text4_2: '14400 USDT a year',
    },
    title3: 'DeepLink recruiting cloud Internet cafe agents globally',
    block3: {
      text1_1: 'Rights',
      text1_2: 'Obtain cloud Internet cafe NFT at a lower price than the market',
      text2_1: 'Responsibilities',
      text2_2: 'Find a cloud Internet cafe partner in the area where the agent is located, and the partner is capable of providing cloud Internet cafe services to the Internet cafe',
      text3_1: 'Qualification criteria',
      text3_2: 'Relevant Internet cafe industry resources in the region are required, and holds amount of DLC Coins equal to the population of the agent region are required',
    },
    title4: 'Cloud Internet Cafes Q&A',
    block4: {
      text1_1: 'What is a Cloud Internet Cafe?',
      text1_2: "Cloud Internet Cafe means that you only need to configure monitors and mini PCs in Internet cafes, and do not need to configure high-end GPUs, and then connect to remote GPU servers through the network. Players can choose to use various types of GPU servers in Internet cafes, and Internet cafes do not need to manage game resources. Internet cafes only need to pay according to the player's usage time.",
      text2_1: 'How to apply to become an agent?',
      text2_2: 'You can contact us by joining Telegram:https://t.me/deeplinkglobal',
      text3_1: 'What benefits can agents get?',
      text3_2: 'Agents have exclusive rights in their area. Agents develop cloud platforms to serve Internet cafes and earn the price difference from each NFT',
      text4_1: 'Does the agent need to sign an agreement with DeepLink official?',
      text4_2: 'Yes, an agreement is required',
      text5_1: 'What impact does the NFT income of Cloud Internet Cafe have on the price of DLC?',
      text5_2: '40% of the NFT income of Cloud Internet Café will be put into the DLC-USDT trading pair in decentralized exchanges such as Uniswap to purchase DLC, and the purchased DLC will be destroyed',
      text6_1: 'How to ensure that the purchase of DLC with the NFT income of Cloud Internet Cafe is transparent?',
      text6_2: 'The number of issued NFTs of Cloud Internet Cafes can be queried on the chain, and the income of NFTs can be calculated through the number of issuance',
    },
    title5: 'Cloud Internet Cafes Partners'
  },
  gameFi: {
    title1: ' Cloud GameFi Platform',
    block1: {
      text1: 'Cloud GameFi Platform',
      text1_1: 'Any user can play GameFi games through DeepLink without downloading',
      text1_2: 'No restrictions on game downloads in any country, no need to download in the Apple Appstore',
      text1_3: 'Help GameFi game manufacturers expand more users',
      text2: 'Cooperation method of game manufacturers',
      text2_1: 'Cooperation on advertising ',
      text2_2: 'Cooperation on traffic',
      text2_3: 'Profit sharing on games',
      text2_4: 'Cooperation on NFT',
    },
    title2: 'GameFi Q&A',
    block2: {
      text1_1: 'What is Cloud GameFi platform?',
      text1_2: 'DeepLink will select high-quality game partners and add the games to the DeepLink cloud platform, so that users can play GameFi games directly through DeepLink without downloading the game',
      text2_1: 'Does the cloud GameFi platform support mobile games?',
      text2_2: 'We will support PC to play mobile games, and can open multiple game windows at the same time',
      text3_1: 'What are the benefits of cooperation between GameFi manufacturers and DeepLink?',
      text3_2: 'DeepLink will help partners bring brand exposure and bring more gamers',
      text4_1: 'Do GameFi manufacturers need to sign an official agreement with DeepLink?',
      text4_2: 'No, DeepLink will screen high-quality partners, and the games that pass the screening will be automatically uploaded to the DeepLink platform',
      text5_1: 'How to I apply to work with DeepLink?',
      text5_2: 'Email us do apply:',
    }
  },
  lanchpad: {
    cont1: {
      title1: 'DeepLink Protocol',
      desc: "The world's first decentralized AI cloud gaming platform protocol",
      title2: 'Building ultra-low latency, AI-driven, GPU-shared rendering infrastructure for cloud gaming',
      btn1: 'Enter PinkSale',
      btn2: 'Download Whitepaper',
      btn3: 'Download Pitch Deck',
      btn4: 'DeepLink Public Sale',
      btn5: 'Purchase node NFTs to earn mining rewards',
      btn6: 'Download the client now',
      "btn7": "How to stake DLC to earn 80% interest?",
      "btn8": "How to redeem DLC on the EVM chain?",
      "btn9": "Trade DLC",
      desc1: 'Support Deeplink get DLC Token',
      desc2: '100% Secure & Verified',
      desc3: 'NVIDlA Inception Program',
      "label1": "Receive DLC address on the DBC EVM chain:",
      "label2": "Transfer amount:",
      "label3": "Please do not use CEX wallets such as Binance Wallet, OKX Wallet, or Coinbase Wallet, as tokens may be lost. Use Metamask instead.",
      "label3_btn": "Confirm send",
      "tis_msg1": "Wallet not connected",
      "tis_msg2": "The specified wallet cannot be empty",
      "tis_msg3": "The transfer amount must be greater than 0",
      "tis_msg4": "Please connect your wallet first",
      "tis_msg5": "Transfer successful! The EVM mainnet wallet DLC tokens will be sent to your specified wallet within 5 minutes.",
      "tis_msg6": "Failed to retrieve transfer data. Please contact the administrator: service{'@'}deeplink.cloud",
      "tis_msg7": "Invalid mainnet wallet address. Please check and re-enter."
    },
    price_cont: {
      title: '$DLC is Live on',
      text: 'DLC Contract Address:'
    },
    cont2: {
      desc1: 'BATTLEFIELD',
      desc2: 'Demonstrated by two computers, for example, 50 kilometers away. The controlling end is an ordinary laptop, and the controlled end is a high-end GPU computer. It displays a dynamic picture of the game within about 3-5 seconds.',
      btn: 'Play the video to learn more'
    },
    cont3: {
      text1: 'Ultra low latency',
      text2: 'High resolution',
      text3: 'Ultra low latency',
      text4: 'No lag, no disconnection, high stability',
      desc1: 'DeepLink Protocol achieves a revolutionary technological breakthrough, bringing an unparalleled perfect experience',
      desc2: 'The core technical team members have been working in the cloud gaming industry since 2011, including Cisco, Intel, Nvidia, Huawei, Shunwang and other companies. DeepLink was established on the foundation of more than 10 years of research and development.'
    },
    cont16: {
      title1_1: 'DeepLink Protocol Provides',
      title1_2: 'ultra-low latency technical services for cloud games',
      title2: 'The products currently developed based on DeepLink Protocol include the following, and more than 20 applications are under development',
      text1: 'Remote control',
      text2: 'Cloud Gaming & Cloud Gaming Platform',
      text3: 'Cloud Internet Cafe',
      text4: 'CloudXR',
      text5: 'XXX Cloud VR Game',
      text6: 'YYY Cloud Game Platform'
    },
    cont4: {
      title1_1: 'DeepLink Protocol uses',
      title1_2: 'remote control tools as traffic entrance',
      title2: 'DeepLink software uses remote control tools as traffic portals, and cloud gaming platforms and cloud Internet cafes as monetization methods',
      text1_1: '900,000+',
      text1_2: 'MAU',
      text2_1: '110 +',
      text2_2: 'Number of countries where services are provided',
      text3_1: '2,500,000+',
      text3_2: 'Total number of users',
      text4_1: '300,000+',
      text4_2: 'DAU',
      desc1: 'Remote tools',
      desc2: 'Cloud Gaming & Cloud XR',
      desc3: 'Cloud Internet Cafe',
      btn1: 'YouTube KOL video 1',
      btn2: 'YouTube KOL video 2',
      btn3: 'YouTube KOL video 3',
      btn4: 'YouTube KOL video 4',
    },
    cont17: {
      title1: "DeepLink Protocol's business model",
      text1: 'Commission model',
      text2: 'License model',
      desc1: 'DeepLink Protocol will charge a 20-30% commission for each cloud game transaction. The commission will be settled in DLC, and 100% of the DLC will be destroyed in real time',
      desc2: 'For cloud Internet cafe and cloud e-sports hotel applications, each application and each computer terminal pay a license fee of US$6 per month.'
    },
    cont5: {
      title1: 'Allow miners to provide idle network traffic through blockchain technology',
      desc1: 'Nodes input',
      desc2_1: 'Equipment needs',
      desc2_2: 'Traffic forwarding',
      desc3: 'Miners over the world get DLC token rewards by purchasing NFT to provide traffic nodes',
      desc3_2: '',
      title2: 'Traffic nodes provider',
      text2: 'Miners provide traffic nodes', 
      title3: 'Users terminal',
      text3: 'Personal Users'
    },
    cont6: {
      title1: 'Greatly enhance the market competitiveness of DeepLink',
      title2: 'Through blockchain technology',
      desc1: 'Pledge digital currency through smart contracts to ensure that GPU providers provide stable services.',
      desc2: 'Everyone can contribute to the network and get rewarded. For example, providing GPU servers and providing traffic nodes.',
      desc3: 'Attract miners to provide traffic forwarding nodes, wide distribution of nodes without requirement of centralized companies to invest in machine deployment nodes, which is decentralized and has zero server cost.',
      desc4: 'Pledging digital currency through smart contracts, investors do not need to wait for 5-10 years, they can exit in about 1 year and get payback.',
      desc5: 'Users can participate in the dividends of project growth, which is conducive to expanding the spread.',
      desc6: 'Users make payment anywhere without limited border.',
      text1: 'Pledge',
      text2: 'Everyone involved', 
      text3: 'Zero cost',
      text4: 'Reduce payback time',
      text5: 'No border', 
      text6: 'User gets bonus'
    },
    cont7: {
      title1: 'We are currently engaging in a dimensional reduction attack of Web2 technology with Web3 technology.',
      desc1: 'To achieve a low-latency gaming experience in cloud gaming, in addition to technical advancements, it is necessary for GPU servers to be located within a range of 50 kilometers from the users. To achieve global coverage, more than 50,000 data centers would be required.',
      title2: 'Traditional centralized cloud gaming platforms.',
      title3: 'DeepLink is a cloud gaming platform based on blockchain technology.',
      text1: 'The platform purchases machines by itself, huge cost causes the payback date is far away.',
      text2: 'Machine coverage is small and cannot be covered globally.', 
      text3: 'Centralized technology cannot support tens of thousands of data center connections.',
      text4: 'Miners and Internet Cafe owners provide GPU servers to get token rewards. Miners have quick payback cycle, and the platform have no pressure to purchase machines.',
      text5: 'A large number of miners and Internet cafes can cover over the world.', 
      text6: 'Distributed blockchain technology supports more than 100,000 data centers and more than 10 million GPU server nodes.'
    },
    cont8: {
      title1: 'DeepLink Token Application Scenarios',
      text1: 'Buy DLC',
      text2: 'Pay DLC', 
      text3: 'Pay USDT',
      text4: 'Pay DLC',
      text5: 'Put DLC and USDT in DEX', 
      text6: 'Sell DLC',
      text7: 'User 1',
      text8: 'DeepLink software', 
      text9: '40% of DLC will be burned directly on the chain.',
      // text10: '1.Buy NFT',
      // text11: '2.Buy cloud gaming time', 
      // text12: '3.Rent Internet Cafe PC time',
      // text13: '4.Buy personal shared gaming time', 
      text10: '1.Purchase a license',
      text11: '2.Purchase cloud gaming hours', 
      text12: '3.Duration of renting an internet café machine',
      text13: '4.Purchase personal shared game time', 
      text14: '40% USDT will be repurchased in DEX and then burned', 
      text15: 'Buy NFT',
      text16: 'DEX and CEX',
      text17: 'Other trading exchanges',
      text18: 'Miner',
      text19: 'Liquidity mining reward',
      text20: 'Reward 2 years, 5 billion DLC per year'
    },
    cont8_new: {
      text7: 'Personal user',
      text12: '3.Duration for renting Internet Cafe machine',
      text21: 'Business users',
      text22: 'DeepLink Protocol',
      // text23: '1.Buy license',
      // text24: '2.10%-20%commission',
      text23: '1.Purchase licenses',
      text24: '2.20-30% Handling fee',
      text25: '100% of the DLC will be destroyeddirectly on-chain',
    },
    cont8_new1: {
      title: 'Top YouTubers supports our project',
      text1: '',
      text2: 'Business users',
      text3: 'DeepLink Protocol',
      text4: '1.Purchase licenses',
    },
    cont9: {
      title1: 'DeepLink Token Liquidity mining reward',
      text1: 'User 1',
      text2: 'Put DLC and USDT in DEX', 
      text3: 'Liquidity mining reward',
      text4: 'Reward 2 years, 5 billion DLC per year',
      text5: 'Put DLC and USDT liquidity on Uniswap and Pancake Swap', 
      text6: 'Rewards are distributed once a day and automatically received through NFT liquidity',
      text7: '80% of which are rewarded to liquidity providers, 20% rewarded to trader.',
      text8: '13,698,630 DLC rewards every day'
    },
    cont9_new: {
      title1: 'DeepLink Token Liquidity mining reward',
      text1: '5% in DLC as well as equivalent values in USDT、ETH and BNB.',
      text2: 'Injected into DEX', 
      text3: 'Enhancing the liquidity of the DEX',
      text4: '',
      text5: 'This 5% of tokens will be sold during the IDO (lnitial DEX Offering). Based on the actual proportion sold, the entirety will eventually be injected into the DEX', 
      text6: 'Injecting DLC and USDT liquidity into DEXs like Uniswap, SushiSwap, Pancake Swap, etc',
      text7: 'This liquidity will be locked for 5 years, and after that, it will be used for the long-term development of the project',
      text8: ''
    },
    cont10: {
      title: 'Roadmap & Plan',
      desc1: 'October 2020',
      text1: 'DeepLink project initiation.',
      desc2: 'March 2021',
      text2: 'Securing seed funding.',
      desc3: 'August 2021',
      text3: 'Release of the first internal development version of DeepLink, achieving a technical latency of 3ms and supporting game keyboards and mouse.',
      desc4: 'May 2022',
      text4: "Release of the first test version of DeepLink's remote control feature, supporting 3K 144Hz displays.",
      desc5: 'August 2022',
      text5: "Release of the third test version of DeepLink's remote control feature, supporting virtual displays.",
      desc6: 'October 2022',
      text6: 'Launch of the official version of DeepLink, supporting Korean, Chinese, and English languages, and establishment of DeepCloudX company in Singapore to operate DeepLink.',
      desc7: 'December 2022',
      text7: 'Securing angel funding.',
      desc8: 'April 2023',
      text8: 'Collaboration with the largest chain of internet cafes in South Korea, setting up a real environment showroom in the cafes for cloud internet cafe testing, receiving positive user feedback.',
      desc9: 'June 2023',
      text9: 'DeepLink surpass 200,000 downloads, with users in 100 countries and support for 8K 60Hz displays.',
      desc10: 'January 2021',
      text10: 'Determining the research and development direction of DeepLink, and starting product design and development.',
      desc11: 'April 2021',
      text11: 'Completion of the core team formation, with team members who have been in the cloud gaming industry since 2011, including founding team members from companies such as Cisco, Intel, Nvidia, Huawei, and Shunwang.',
      desc12: 'March 2022',
      text12: 'Testing DeepLink in the internet cafe industry, achieving a technical latency of 1ms.',
      desc13: 'July 2022',
      text13: "Release of the second test version of DeepLink's remote control feature, supporting privacy screens and remote file copying.",
      desc14: 'September 2022',
      text14: "Release of the fourth test version of DeepLink's remote control feature, supporting multiple streaming and 444 true color.",
      desc15: 'November 2022',
      text15: 'Set up 10 mini PC machines and display simulations in Seoul for cloud internet cafe testing.',
      desc16: 'February 2023',
      text16: 'DeepLink surpass 100,000 downloads, with users in 50 countries and support for 4K 200Hz displays.',
      desc17: 'May 2023',
      text17: 'DeepLink surpass 150,000 downloads, with users in 80 countries and support DLC wallet, as well as support Vietnamese and Japanese languages.'
    },
    cont11: {
      title: 'Development Plan',
      desc1: 'July 2023',
      text1: 'Support the device list and referral reward feature.',
      desc2: 'August 2023',
      // text2: 'Support NFT functionality and officially launch the first cloud internet cafe in Seoul.',
      text2: 'Launch the first cloud internet cafe in Seoul.',
      desc3: 'October 2023',
      // text3: 'Support personal computer and internet cafe computer sharing, with the goal of reaching over 400,000 downloads for DeepLink.',
      text3: 'Support sharing reward function',
      desc4: 'December 2023',
      // text4: 'Launch the GameFi platform, supporting Arabic, German, French, Spanish, Thai, and Turkish languages.',
      text4: 'Support NFT functionality',
      desc5: 'Q1 2024',
      text5: 'Support game sharing feature for the WEB version and establish partnerships with target to reach over 0.5 million downloads for DeepLink',
      desc6: 'Q2 2024',
      text6: 'Target to reach over 1 million downloads for DeepLink, with 10 cloud internet cafes.',
      desc7: 'Q3 2024',
      text7: 'Target to reach over 2 million downloads for DeepLink,  partnerships with 30 cloud internet cafes',
      desc8: 'Q4 2024',
      text8: 'Target to reach over 2.5 million downloads for DeepLink, partnerships with 40 cloud internet cafes',

      desc9: 'Q1 2025',
      text9_1: 'Expansion of Internet Café Functions:',
      text9_2: 'Support for renting out idle Internet café machines to achieve resource sharing',
      text9_3: 'Support for Cloud Gaming:',
      text9_4: 'Initial implementation of cloud gaming functionality to provide an efficient and convenient gaming experience',
      desc10: 'Q2 2025',
      text10_1: 'Basic Function Development:',
      text10_2: 'AI-driven virtual game characters',
      text10_3: 'Develop a virtual character that can be activated at any time',
      text10_4: 'Cloud gaming optimization: Improve performance, reduce latency, and enhance resource efficiency',
      text10_5: 'Enable AI agents to recognize the user’s game interface in real-time and provide targeted gaming guidance',
      text10_6: 'Voice control function: Implement voice commands to direct AI agents in executing game operations, enhancing interaction efficiency',
      text10_7: 'Cloud gaming optimization: Improve cloud gaming performance, reduce latency, and increase resource utilization efficiency',
      desc11: 'Q3 2025',
      text11_1: 'AI Agent Game Operation: Enable the AI Agent to proactively assist users with basic game operations, such as task guidance and resource collection',
      text11_2: 'Milestones:',
      text11_3: 'Surpassed 5 million users',
      text11_4: 'Shared GPUs exceeded 3,000',
      text11_5: 'Partnered with over 150 cloud internet cafés',
      desc12: 'Q4 2025',
      text12_1: 'AI Agent Intermediate Game Operations: Develop the ability for the virtual character to handle medium-difficulty game tasks, such as strategy optimization and combat assistance',
      text12_2: 'Milestones:',
      text12_3: 'Surpassed 6 million users',
      text12_4: 'Shared GPUs exceeded 4,000',
      text12_5: 'Partnered with over 200 cloud internet cafés',
      desc13: '2026',
      text13_1: 'AI Agent Advanced Game Operations:',
      text13_2: 'Enable the virtual character to proactively perform advanced game operations, including global strategy planning and completing high-difficulty tasks, further enhancing user gaming experiences',
      text13_3: 'With the goal of reaching over 15 million downloads for DeepLink, 50,000 shared computers, and partnerships with 800 cloud internet cafes',

      // desc9: '2025',
      // text9: 'Support multiple brands of VR and AR devices, with the goal of reaching over 6 million downloads for DeepLink, 20,000 shared computers, and partnerships with 300 cloud internet cafes.',
      // desc10: '2026',
      // text10: 'With the goal of reaching over 15 million downloads for DeepLink, 50,000 shared computers, and partnerships with 800 cloud internet cafes.'
    },
    cont12: {
      text: '100 billion will be issued on the DBC EVM chain',
      text1: 'Investment',
      text1_1: 'Seeding Round',
      desc1_1: '2 month cliff, 20 month linear vesting',
      text1_2: 'Angel Round',
      desc1_2: '1 month cliff, 10 month linear vesting',
      text1_3: 'A Round',
      desc1_3: '1 month cliff, 10 month linear vesting',
      text1_4: 'Public Sale',
      desc1_4: '100% release before TGE',
      text2: 'Team',
      desc2: '2 month cliff, 20 month linear vesting',
      text3: 'Airdrop',
      desc3: '20% unlock before TGE, 8 month linear vesting ',
      text4: 'NFT Sales',
      desc4: '20% unlock before TGE, 8 month linear vesting',
      text5: 'Mining',
      text5_1: 'GPU',
      desc5_1: '16% is for miners providing GPU power, which halves every 4 years. Mining rewards starts  after TGE. Mining rewards halving every 4 year. 25% of the mining rewards unlock immediately, and the rest follow  a 150 day linear unlocking schedule',
      text5_2: 'Bandwith',
      desc5_2: '4% is for bandwidth mining, which halves every 4 years. Mining rewards starts  after TGE. Mining rewards halving every 4 year. 25% of the mining rewards unlock immediately, and the rest follow  a 150 day linear unlocking schedule',
      text5_3: 'Race',
      desc5_3: '0 month cliff ,  10% of the mining rewards unlock immediately, and the rest follow  a 180 day linear unlocking schedule',
      text6: 'Foundation',
      desc6: '6 month cliff, 8 Quarter linear vesting',
      text7: 'Legal Advisor',
      desc7: '1 month cliff ，10 month linear vesting',
      text8: 'Ecosystem',
      desc8: '20% unlock before TGE, 8 month linear vesting',
      text9: 'Staking',
      text9_1: 'Long',
      desc9_1: '0 month cliff , 180 day linear vesting',
      text9_2: 'Short',
      desc9_2: '0 month cliff , 90 day linear vesting',
      text10: 'Total',
      text11: 'Quantity (billion)：',
      text12: 'Description：',
      text13: 'In circulation (billion) ：',
      text14: 'Not in circulation (billion) ：',
      text15: '100 billion',
      text16: 'Liquidity',
      desc16: '0 month cliff ，0 month linear vesting',
    },
    cont14: {
      title: 'Our Early Stage Investors',

      organ1: 'DeepBrain Chain Foundation was established in 2017. In January 2018, DBC Token was listed on Huobi Exchange. The main network was launched in 2021. DeepBrain Chain is a high-performance distributed computing power network with GPU as the core. The vision is based on blockchain technology Construct a distributed high-performance computing power network with unlimited expansion, and become the most important computing power infrastructure in the era of AI+Metaverse. It mainly provides GPU computing services for artificial intelligence, cloud games, movie rendering and other fields. At present, it has served hundreds of artificial intelligence and cloud game-related companies and more than 30,000 AI practitioners',
      organ2: "Gobi Partners is a professional venture capital firm with offices in Shanghai, Beijing, and Southeast Asia. They specialize in investing in early-stage technology projects in China. Gobi Fund's strategic investors include IBM, Sierra Ventures, The McGraw-Hill Companies, and Steamboat Ventures (Disney's venture capital division). They have previously invested in well-known startups such as Tuniu, Camera360, and Zhuyun. Gobi Partners is an established investment fund in the industry",
      organ3: "Hycons is a GPU computing cloud platform based on DBC technology developed by Hyunjin ICT. Hycons stands out with its DBC-based distributed high-performance network technology and DeepLink-based lag-free HD streaming technology. The platform provides comprehensive services such as membership management, registration and payment for different service types such as enterprises, schools, research institutions and franchisees. Currently, more than 1,000 GPU cards and 2 centers are in operation in Korea, and it is planned to expand to 5 centers in the future. In addition, Hycons is testing it by applying it to the franchise business of Internet cafes. With advanced technology foundation, competitive cloud service rates and automated service capabilities, Hycons aims to become the world's leading GPU computing platform.",
      organ4: 'ROCK Capital is a specialized cryptocurrency fund company founded in Korea in 2018, bringing together professional resources in finance and investment, as well as blockchain and decentralization experts. With extensive collaboration with various domestic and international businesses, global projects, governments, institutions, and other economic entities, ROCK have successfully executed over 100 projects, pioneering diverse areas of future finance. Through strengthened collaboration, growth, activation, and partnerships, ROCK possesses rich experience and expertise in diverse market environments. Upholding unwavering principles like a rock, ROCK strive to generate high returns, expand investment opportunities, and maximize capital activities, creating concrete customer experiences.',
      organ5: 'A Decentralized blockchain focused on emerging technology that will power the 4th and 5th revolution. The VC has a wealth of knowledge from different beings from all walks of life, which aids them in capturing opportunities throughout the web3 space and beyond. They have invested alongside known names like Bloktopia, Animoca Brands, Stripe, etc. They have secured relationships with the singularityNet and Shiba ecosystems and various gaming studios. Their VC is grassroots and accessible to those holding a BTR-Army pass.'
    },
    cont15: {
      title: 'Community events',
      name1: 'Vietnam MARVELS HCMC DeepLink',
      name2: 'Vietnam Web3 event speech',
      name3: 'Deeplink Hong Kong Events',
      name4: 'IIITB Indian University DeepLink',
      name5: 'IIT Sri City Indian University DeepLink',
      name6: 'IIT Tirupati Indian University DeepLink',
      name7: 'NIT Warangal Indian University DeepLink',
      name8: 'DeepLink Singapore Events',
      name9: 'DeepLink Singapore Events',
      name10: 'Vietnam ESPORTS3.0 EVENT',
      name11: 'DEEPLINK Investor Day in Seoul, South Korea',
      name12: 'DEEPLINK Investor Day in Tokyo, Japan',

      name13: 'DEEPLINK in the TEAMZ/WEB3 SUMMIT, Tokyo Japan',
      name14: 'DEEPLINK Sponsors the HTX Dubai Whale Night',
      name15: 'DEEPLINK at the Lbank Dubai Night',
      name16: 'DEEPLINK Sponsors the HOT Crypto Twist with MTCAPITAL and Tido Capital',
      name17: "DEEPLINK and Animoca's Dubai Game Night",
      name18: 'DeepLink at the Token2049 Dubai afterparty',
      name19: "DEEPLINK's presentation at BYBIT event",
      name20: "DeepLink participated in the 2024 Tokyo Blockchain Expo",
      name21: 'Brando, Advisor to DeepLink, Presents Keynote Address at Depin House Consensus Conference Hosted by IOTX',
      name22: "DeepLink Principal Consultant is attending the Investor Conference Forum in Austin, USA",
      name23: "DeepLink’s Cornerstone Investor Mr. Adam Ha, participated in the DEPIN ALLIANCE YACHT PARTY ⛵️panel and introduced DeepLink to the Vietnam market",
      name24: "We co-organized a blockchain event in Seoul with {'@'}DeepBrainChain and ETNEWS, Korea's top IT news media.",
      name25: "DeepLink Protocol Successfully Participates in Stanford 'The Future of Decentralized AI' Summit.",
      name26: "Team leaves yet another foot print in Tokyo, Japan at the  {'@'}13Desk Meet Up",
      name27: "The turn up was great in Japan as always. Thank you for the continued support.",
      name28: "🚀 Exciting moments captured at InnoBlock Singapore Web3 Token2049 Week",
      name29: "🚀 DeepLink is proud to be part of the sponsors for The Carnival organized by {'@'}okxweb3 The World's Leading OKX Assets Platform.",
      name30: "🥳Check a sneak peak of the Seraph with Friends event in Dubai😍",
      name31: "🌐DeepLink Protocol showcased its cloud gaming & esports tech at the Korean National Internet Cafe Association conference, engaging with 80% of 🇰🇷 internet cafe owners. ",
      name32: "{'@'}DeepLinkGlobal has an upcoming Massive Airdrop Event on Binance Wallet. {'@'}Web3WithBinance🎉",
    },
    cont19: {
      title: 'Investors',
      text: 'Esteemed Investors from the tech and web3 space empower us to push boundaries and redefine the future.'
    },
    cont20: {
      title: 'Featured Partners',
      text: 'Our network of strategic alliances drive bringing deep expertise and bold thinking to accelerate our impact in tech and Web3'
    },
    report: 'DeepLink Media Report'
  },
  homeNew: {
    // cont1: {
    //   text1: 'Redefine Remote Control',
    //   text2: 'Remote control without delay can be achieved with DeepLink',
    //   text3: 'Now only supports Windows environment'
    // },
    cont1: {
      title: 'Download DeepLink for Ultra-Low Latency Cloud Gaming and Remote Gaming',
      text: 'Al cloud gaming platform leveraging blockchain and GPU clusters for ultra-low-latency, high-scalability gaming on any device. Control any device remotely without any delay'
    },
    cont2: {
      title: 'Introduction to remote control',
      block1: {
        title: 'What is remote control',
        text: 'The act of remotely controlling computers or machines in different locations through the Internet'
      },
      block2: {
        title: 'Remote control type',
        text: 'Remote control is divided into client/server-based remote control and P2P point-to-point remote control'
      },
      block3: {
        title: 'Remote control function',
        text: 'You can share files between multiple computers, help secure remote education, and more'
      },
      block4: {
        title1: 'DeepLink',
        title2: ' Advantages of remote control',
        text: 'Through blockchain technology, we solve the problem of decentralization and provide the best gaming experience with e-sports grade ultra-low latency and no interruptions'
      }
    },
    cont3: {
      title: 'Traditional remote control tools make simple tasks difficult to complete',
      text1: 'Connection delay',
      text2: 'Frequently disconnected',
      text3: 'Frame rate drops',
      text4: 'Expensive fees'
    },
    cont4: {
      title1: "Now it's like controlling a local computer",
      title2: 'Smooth!',
      desc: 'Solve distributed problems through smart contract technology and experience fast and powerful remote control functions',
      text1: 'Easy and quick access',
      text2: 'Support 8K',
      text3: 'High performance game optimization',
      text4: 'No interruption',
      text5: 'Optimization of work tools',
      text6: 'Free to use'
    },
    cont5: {
      title1: 'Strong and smooth',
      title2: 'Remote game',
      title3: 'Can be used anytime and anywhere',
      text1: 'Battlefield',
      text2: 'League of Legends',
      text3: 'VALORANT'
    },
    cont6: {
      title1: 'Heavy and expensive gaming laptop',
      title2: 'And DeepLink',
      title3: 'Lightweight and affordable',
      title4: '',
      text1: 'At least 1,400 dollar',
      text2: 'At least 1.6kg or more',
      text3: 'High performance notebook',
      text4: '0 dollar'
    },
    cont7: {
      title1: 'Various ways to use',
      title2: 'Very versatile',
      block1: {
        text1: 'External',
        text2: 'for work',
        text3: 'Notebook'
      },
      block2: {
        text1: 'Office, home',
        text2: 'High performance',
        text3: ' Desktop machine',
        text4: 'High performance work',
        text5: 'High performance gaming'
      },
      block3: {
        text1: 'Customer',
        text2: 'Work together',
        text3: 'Remote office'
      },
      title3: 'While supporting powerful technology',
      title4: 'Ensuring comprehensive security',
      block4: {
        text1: 'Account security',
        text2: 'Based on blockchain technology',
        text3: 'Multiple account protection mechanism'
      },
      block5: {
        text1: 'Connection security',
        text2: 'DTLS1.2 protocol protection'
      },
      block6: {
        text1: 'Data security',
        text2: '256 BIT AES encryption'
      },
      block7: {
        text1: 'Machine security',
        text2: 'User permissions can be set'
      }
    },
    cont8: {
      title1: 'Using DeepLink',
      title2: 'Connect anytime, anywhere',
      text1: 'As long as there are nodes, you can play high-performance games remotely and seamlessly. Connect your blockchain node computer and play online high-performance games from any country or location',
      title3: 'Use DeepLink flexibly',
      title4: 'Collaborative work',
      text2: "DeepLink's ultra-low-latency remote connections enable stronger collaboration. Optimized for designers, planners and developers"
    },
    cont9: {
      title1: 'Not just a game',
      title2: 'It also provides productivity tools for employees'
    },
    cont10: {
      title1: 'With DeepLink',
      title2: 'Get rid of space and technology constraints',
      block1: {
        name: 'Hyun Choi',
        desc: 'IT Operations and Remote Maintenance Manager',
        text1: 'Remote work support without delay',
        text2: 'Improved customer satisfaction'
      },
      block2: {
        name: 'Sangwo Baek',
        desc: 'Gamer',
        text1: 'Now you only need a sales laptop to play high-performance games on the road',
        text2: 'I never thought it was possible'
      },
      block3: {
        name: 'Junho Kim',
        desc: 'sales representative',
        text1: 'No device restrictions',
        text2: 'I can conduct business using only my laptop'
      },
      block4: {
        name: 'Min Kyung Yoo',
        desc: 'remote work designer',
        text1: 'I can work anytime, anywhere, no need to download',
        text2: 'Connect to headquarters computer for work'
      },
    },
    cont11: {
      title: 'What is DeepLink Wallet',
      text1: 'Secure account protection system',
      desc1: 'DeepLink wallet uses blockchain technology, 256-bit AES encryption and a multi-layer account protection mechanism based on device information to support a robust and secure account protection system',
      text2: 'Trade and use tokens securely',
      desc2: 'Wallets enable more secure token transactions and usage compared to transactions via smart contracts and peer-to-peer cryptocurrency transfers',
      text3: 'DeepLink can be used around the world',
      desc3: 'As long as you have the wallet private key, you can log in to your private wallet and play games through DeepLink from anywhere in the world'
    },
    cont12: {
      title1: 'Ultra-low latency remote gaming',
      title2: 'Start DeepLink now!',
      text1_1: 'Please download',
      text1_2: 'DeepLink Client',
      text2_1: 'Register as a DeepLink member',
      text2_2: 'Need to generate a personal wallet',
      text2_3: '',
      text3_1: 'After wallet generation',
      text3_2: 'Access the required device and start DeepLink',
      text3_3: ''
    }
  },
  cloudInternet: {
    title: 'How to Become a Cloud Internet Café Solution Provider',
    text: 'Currently, major internet café distribution countries globally include South Korea (6,000), China (40,000), Brazil (10,000), Indonesia (20,000), the Philippines (20,000), Vietnam (15,000), Turkey (5,000), as well as India, Mexico, the Middle East, South America, Africa, Europe, and other countries. Globally, there are over 150,000 internet cafés. However, the internet café industry has a history of 20 years and has become a traditional industry. The payback period has increased to 3-4 years, and it faces various risks. For example, the COVID-19 pandemic has led to the closure of a large number of internet cafés. Therefore, the internet café industry needs a new solution to reduce the payback period, mitigate risks, and improve operational efficiency. Thus, the cloud internet café solution is born.',
    cont2: {
      text1: 'What is ',
      text2: 'A Cloud Cybercafe Solution?',
      text3: 'A cloud cybercafe solution is a new type of cybercafe service model with ultra-low latency rendering technology. In a cloud cybercafe, games and applications are not installed directly on local computers but hosted on cloud GPU servers. Users access and play games through cloud services without the need for high-performance local hardware.',
      block1: {
        text1: 'Reduce Local Hardware Requirements',
        text2: 'Since games and applications run on cloud GPU servers, local computers do not require high-performance GPUs or large storage space. This reduces cybercafe hardware investment and maintenance costs.'
      },
      block2: {
        text1: 'Instant Access to Latest Games',
        text2: 'Users can access the latest games instantly without waiting for download and installation. All game updates and maintenance are done in the cloud, providing users with convenient and efficient experiences.'
      },
      block3: {
        text1: 'High-Performance Gaming Experience',
        text2: 'Local monitors only need to be equipped with mini PCs (around $100), and cloud cybercafes can still provide high-performance gaming experiences. This is because game computing is done on remote high-performance GPU servers.'
      },
      block4: {
        text1: 'Space and Energy Saving',
        text2: 'Lower-configured local computers occupy less space and consume less power, helping to reduce cybercafe operating costs.'
      },
      block5: {
        text1: 'Easy Management and Maintenance',
        text2: 'Cybercafe managers can more easily manage software and games because all content is centrally managed in the cloud. This reduces local maintenance work and potential technical issues.'
      }
    },
    cont3: {
      text1: 'Glowsteam Cloud Cybercafe in South Korea',
      text2: 'Actual Operating Environment of Cloud Cybercafe'
    },
    cont4: {
      text1: 'Cloud Cybercafe Solution Can Help Cybercafe Investors',
      text2: 'Increase Net Profit by 3 Times and Shorten Payback Period by 40%',
      text3: 'Click to Download Comparative Data'
    },
    cont5: {
      text1: 'How Do Cloud Cybercafe Solution Providers Profit?',
      text2: 'If the profit is calculated as 12% of the earnings per cybercafe machine, then servicing a total of 1000 cybercafes with 100,000 machines, each machine being used an average of 10 hours per day, and with an average cost of $0.8 per machine per hour, 12% equals approximately $0.1.',
      text3: 'The annual profit of a cloud cybercafe solution provider is',
      text4: '100,000 * 10 * 0.1 * 365 = $36.5 million',
      text5: 'How to Become a Cloud Cybercafe Solution Provider',
      text6: "Based on DeepBrainChain and DeepLink technologies, South Korea's HYCONS has developed a complete cloud cybercafe solution. DeepBrainChain provides GPU computing power, DeepLink offers ultra-low latency rendering technology, and HYCONS delivers the entire solution. Analogously, if we compare it to a car, DeepBrainChain provides the engine, DeepLink provides the autonomous driving system, and HYCONS provides the complete car solution. Local solution providers in various countries only need to integrate their local payment systems into HYCONS to provide services to local cybercafes, and solution providers can set their own brands. HYCONS acts solely as a technology service provider without exposing its brand.",
      text7: 'For more information, please contact:',
      text8: "service{'@'}deeplink.cloud"
    },
      cont6: {
      title: 'Download Cloud Cybercafe Related Materials',
      text1: 'HYCONS Introduction',
      text2: 'Cloud Cybercafe Solution Profit Analysis',
      text3: 'Cloud Cybercafe Data Center Architecture Diagram',
      text4: 'Cloud Cybercafe Solution Testing and Installation Manual',
      text5: 'DeepLink Protocol Introduction'
    }
  },
  reward2: {
    title: 'How to Operate DeepLink Nodes',
    step: {
      title1: 'Buy Nodes',
      title2: 'How to run Nodes',
      title3: 'Earn $ DLC',
      text1: 'Node Tier 5 is currently on sale',
      text2_1: '1. GPU Mining: (Nvidia GPU Servers)',
      text2_2: '2. Bandwidth Mining VPS/Cloud Server',
      text3: 'Join the DeepLink ecosystem, contribute your computational power and earn rewards',
      btn1: 'Buy Here',
      btn2: 'Learn more',
    },
    title1: 'PC Cafe Partners',
    text1: 'Short Term Rental Participants',
    partnet: {
      partnet_text1_1: 'Purple Cow, South Korea',
      partnet_text1_2: 'No. of Machines: 60',
      partnet_text1_3: 'Phase 2: Estimate income $2,400/month',
      partnet_text2_1: 'Iris PC Cafe, South Korea',
      partnet_text2_2: 'No. of Machines: 2',
      partnet_text2_3: 'Phase 2: Estimate income $ 80/month',
      partnet_text3_1: 'Hera PC Cafe, South Korea',
      partnet_text3_2: 'No. of Machines: 10',
      partnet_text3_3: 'Phase 2: Estimate income $ 400/month',
      partnet_text4_1: 'G7 PC Cafe, South Korea',
      partnet_text4_2: 'No. of Machines: 30',
      partnet_text4_3: 'Phase 2: Estimate income $ 1200/month',
      partnet_text5_1: 'Sharp PC Cafe, South Korea',
      partnet_text5_2: 'No. of Machines: 12',
      partnet_text5_3: 'Phase 2: Estimate income $ 480/month',
      partnet_text6_1: 'How to calculate your estimate income, with your GPU Specs'
    },
    desc: {
      title1: 'DeepLink Nodes',
      text1: 'Only Node owners can participate in CPU traffic mining and personal GPU machine mining. The total reward is 12% of DLC Tokens, 4% for CPU traffic nodes, and 8% for personal GPU nodes. The total token amount is 12 billion. The output per node is related to the actual number of nodes sold. If all are sold, each node will produce 100,000 DLC. If only 10% of the nodes are sold, each node will produce 1 million DLC.',
      title2: 'Total Nodes: 120,000 No additional issuance',
      text2: 'Each Node receives additional airdrops',
      text3: 'The minimum amount of DLC mined per Node',
      text4: 'Initial price',
      text5: 'Maximum price'
    },
    btn_text: 'Buy Nodes',
    table: {
      tier: 'Tier',
      license: 'Node License Price (USDT)',
      total_num: 'Total Licenses',
      total_usdt: 'Total USDT',
      buy: 'Buy'
    },
    intro: {
      title: 'Node Mining Introduction',
      text1_1: 'The more network users DeepLink has, the more network traffic and computing power it requires, which leads to the need for more CPU traffic machines and more GPU computing machines to provide infrastructure for the DeepLink network, achieving decentralization and helping DeepLink grow faster. By purchasing node authorization, you have the opportunity to participate in mining and earn rewards. Have any questions? Come',
      text1_2: 'and',
      text1_3: 'chat with us above.',
      text2: 'Each node is issued as an NFT and additionally receives a 30,000 DLC airdrop on the DBC EVM chain. 20% of the airdropped DLC unlocks immediately, while 80% unlocks over 8 months.\n(To check the DLC Token: Open your wallet, select the DBC EVM network, choose to add a Token, and enter the contract address: 0x6f8F70C74FE7d7a61C8EAC0f35A4Ba39a51E1BEe)',
      text3: 'Nodes are transferable to another wallet',
      text4: '25% of the mined tokens are unlocked immediately, with 75% unlocked linearly over 150 days.',
      // text5: 'If mining does not start within 10 days after the listing, rewards will be distributed through airdrops, with airdrops occurring every 7 days. The airdrop rules are the same as the mining output rules, with a total daily output of 4.1 million DLC evenly distributed based on the total number of nodes sold. 25% unlocks immediately, and 75% unlocks linearly over 150 days. If mining has already started, corresponding machines are required to receive rewards.',
      text5: 'For purchases of more than 20 nodes, 1:1 technical support can be delegated. Please Note: Miners still need to have GPU Servers or VPS Cloud Servers. We will offer full support guide on setting up your machine.',
      text6: 'One virtual machine can support 20 NFT nodes, and the income is multiplied by 20 times.',
      text7: 'Buy DeepLink nodes and Participate in the $9 Million Orion GPU Computing Power Competition: '
    },
    question: {
      ques1: 'How many Node NFTs are sold in total?',
      ans1: 'A total of 120,000',
      ques2: 'How much does each Node NFT cost?',
      ans2: 'It is divided into 10 tiers, with prices ranging from 30U to 155U, sold on the official website until sold out',
      ques3: 'Is purchasing a Node NFT a one-time payment?',
      ans3: 'Yes, purchasing a Node is a one-time payment, and no additional fees are required in the future',
      ques4: 'Are there additional airdrops for purchasing a Node NFT?',
      ans4: 'Yes, each node owner receives an airdrop of 30,000 DLC. 20% of the airdropped DLC is unlocked immediately, and 80% unlocks over 8 months',
      ques5: 'What is the specific mining mechanism?',
      ans5: 'The total reward is 12 billion DLC. The total earnings for traffic nodes are 4 billion DLC, and the total earnings for personal GPU machine nodes are 8 billion DLC. By purchasing a Node NFT, you can participate in both types of mining simultaneously. The reward for the first 4 years is 1.5 billion DLC per year, with halving every 4 years. The total daily reward is 4.11 million DLC, distributed only to Node NFT owners. 25% of the mined tokens are unlocked immediately, with 75% unlocked linearly over 150 days',
      ques6: 'Can a purchased Node NFT participate in both CPU traffic machine and personal GPU machine mining?',
      ans6: 'Yes',
      ques7: 'What is a CPU bandwidth traffic machine node?',
      ans7: 'The CPU bandwidth traffic machine node undertakes the core task of computation and traffic forwarding in the DeepLink network. Through the mining model, DeepLink allows more people to participate and earn rewards. The total earnings for traffic nodes are 4 billion DLC',
      ques8: 'What is the total reward for bandwidth traffic machines in the first year?',
      ans8: 'The first-year reward is 500 million DLC, with approximately 1.37 million DLC rewarded daily',
      ques9: 'How does the bandwidth of each CPU bandwidth traffic machine node relate to its earnings?',
      ans9: 'The base bandwidth is 10Mb uplink bandwidth. The bandwidth value is 10 for 10Mb uplink bandwidth. The bandwidth is only valid in multiples of 10, for example, 45Mb uplink bandwidth is calculated as 40 in bandwidth value. Bandwidth increases by 30% according to actual usage. Finally, earnings are divided according to the actual bandwidth value',
      ques10: 'Are the configuration requirements for bandwidth traffic machine nodes high? Is there any configuration information? How do you participate in mining?',
      ans10: 'The configuration requirements are not high. vCPU 1C + 2G memory + 30G hard disk. Renting on AWS costs around 10 USD per month, with bandwidth charged according to actual usage. After renting a CPU virtual machine on AWS, install the DeepLink traffic node mining program, create a wallet address, transfer the Node NFT to the wallet, and activate the mining function to participate in mining',
      ques11: 'What is a personal GPU machine node?',
      ans11: 'Individuals can offer their GPU computers to participate in mining. The GPU machines provide cloud gaming infrastructure services for the DeepLink Protocol. The total earnings for personal GPU machine nodes are 8 billion DLC',
      ques12: 'What is the total reward for personal GPU machine nodes in the first year?',
      ans12: 'The first-year reward is 1 billion DLC, with approximately 2.74 million DLC rewarded daily',
      ques13: 'What are the machine configuration requirements for personal GPU machine nodes? How do you participate in mining?',
      ans13: 'The configuration requirements for GPU machines are: CPU frequency of at least 3.0GHz, GPU from Nvidia Geforce series: 20xx, 30xx, 40xx, and at least 16G of memory'
    }
  },
  BandWidth: {
    "title": "Traffic Bandwidth Mining Rules",
    "text1": "Traffic bandwidth mining has a total reward of 4 billion DLC, with 500 million DLC awarded each year for the first four years, halving every four years.",
    "cont2": {
      "title": "Participation Rules",
      "text1_1": "Node NFT ownership is required (each node grants an airdrop of 30,000 DLC, learn more about nodes: ",
      "text1_2": "). A single CPU machine can hold multiple nodes, and the reward in tokens is proportional to the number of nodes. The maximum number of Node NFTs a single machine can hold is 20.",
      // "text2_1": "Minimum requirements for CPU servers: \n The parameters of the computing server must meet the minimum requirements",
      "text2_1": "Minimum requirements for CPU servers: \n Miners should prepare a cloud server in advance. We recommend using cloud platforms like AWS, with each requiring an independent public IP address. \n The parameters of the computing server must meet the minimum requirements:",
      "text3_1": "CPU",
      "text3_2": "vCPU 1C",
      "text4_1": "Memory",
      "text4_2": "2G",
      "text5_1": "Hard Disk:",
      "text5_2": "30G hard disk",
      "text6_1": "Network Bandwidth:",
      "text6_2": "The basic bandwidth is 10Mb upload; it is recommended to add 1C CPU and 2G memory for every 200M increase in bandwidth"
    },
    cont3: {
      title: 'Traffic Mining Regional Rules',
      text: 'Traffic mining will divide the world into about 130 regions, each region is allocated a different total number of DLC rewards, and the regional rewards formula is, regional rewards = regional value * daily reward / total regional value',
      text1: 'The list of regions is as follows:',
      text2: 'Asia',
      text3: 'Americas',
      text4: 'Europe',
      text5: 'Africa',
      text6: 'Oceania',
      li_other: 'Other',
      li1: 'China',
      li1_1: 'North China',
      li1_2: 'Northeast China',
      li1_3: 'East China',
      li1_4: 'Central China',
      li1_5: 'South China',
      li1_6: 'Southwest China',
      li1_7: 'Northwest China',
      li1_8: 'Taiwan, China',
      li1_9: 'Hong Kong, China',
      
      li2: 'India',
      li2_1: 'Uttar Pradesh',
      li2_2: 'Maharashtra',
      li2_3: 'Bihar',
      li2_4: 'Indonesia',
      li2_5: 'Pakistan',
      li2_6: 'Bangladesh',
      li2_7: 'Japan',
      li2_8: 'Philippines',
      li2_9: 'Vietnam',
      li2_10: 'Turkey',
      li2_11: 'Thailand',
      li2_12: 'South Korea',
      li2_13: 'Malaysia',
      li2_14: 'Saudi Arabia',
      li2_15: 'United Arab Emirates',

      li3: 'United States',
      li3_1: 'California',
      li3_2: 'Texas',
      li3_3: 'Florida',
      li3_4: 'New York',
      li3_5: 'Pennsylvania',
      li3_6: 'Illinois',
      li3_7: 'Ohio',
      li3_8: 'Georgia',
      li3_9: 'Michigan',
      li3_10: 'North Carolina',
      li3_11: 'Other Regions of the USA',
      
      li4_1: 'Mexico',
      li4_2: 'Canada',
      li4_3: 'Brazil',
      li4_4: 'Colombia',
      li4_5: 'Argentina',
      
      li5: 'Russia',
      li5_1: 'Moscow',
      li5_2: 'Saint Petersburg',
      li5_3: 'Other parts of Russia',
      li5_4: 'Germany',
      li5_5: 'United Kingdom',
      li5_6: 'France',
      li5_7: 'Italy',
      li5_8: 'Spain',
      li5_9: 'Netherlands',
      li5_10: 'Switzerland',
      
      li6_1: 'Nigeria',
      li6_2: 'Egypt',
      li6_3: 'South Africa',
      
      li7_1: 'Australia',
    },
    cont5: {
      title: "Reward Mechanism (Based on DBC AI public chain's EVM-compatible DLC, Browser URL: https://dbcscan.io/)",
      text1: 'For the first four years, the annual mining reward is 500 million DLC, daily being 1.369 million DLC. Each region is allocated DLC rewards based on weight proportions. If a region has no machines, the DLC rewards for that region are automatically destroyed and allocated to no one.',
      text2: "The total token amount rewarded each day per region in this system is fixed. The reward a machine receives depends on the machine's bandwidth, the effective mining time Y, and the number of staked tokens. The more tokens staked, the greater the reward, but it grows in a non-linear relationship. The reward base is the same for 0-10,000 coins; rewards correlate with a function when exceeding 10,000 coins.",
      text3: "If the machine's traffic bandwidth is in use, the computing power value increases by 30%, and the number of node NFTs is a multiplier of the computing power. Currently, each machine can hold up to 20 node NFTs.",
      text4: 'Only machines with node NFTs are eligible for online rewards.',
      text5: 'Currently, a single machine can bind up to 20 node NFTs, with more NFTs resulting in more rewards, showing a linear relationship.',
      text6: 'For the first 300 days, a single machine can bind up to 20 node NFTs.',
      text7: 'For the first 600 days, a single machine can bind up to 10 node NFTs.',
      text8: 'From 600 to 900 days, each machine can bind up to 5 node NFTs.',
      text9: 'From 900 to 1200 days, each machine can bind up to 2 node NFTs.',
      text10: 'From 1200 to 1800 days, each machine can bind up to 1 node NFT.',
      text11: 'After 1800 days, each node NFT can bind to 2 machines.',
      text12: 'After 2400 days, each node NFT can bind to 4 machines.',
      text13: 'Calculating rewards:',
      text14: 'R: Total daily reward Token amount (fixed value)',
      text15: 'The number of staked tokens of the i-th machine',
      text16: 'The computing power value of the i-th machine',
      text17: 'The effective mining time of the i-th machine',

      text18: 'Where N is the total number of machines participating in mining',
      text19: 'The reward for 100,000 coins is 1.23026 times that of staking 10,000 coins, an increase of approximately 23.03%',
      text20: 'The reward for 1 million coins is 1.46052 times that of staking 10,000 coins, an increase of approximately 46.05%',
      text21: 'The reward for staking 10 million coins is 1.69078 times that of staking 10,000 coins, an increase of approximately 69.08%',
      text22: 'The reward for staking 100 million coins is 1.92103 times that of staking 10,000 coins, an increase of approximately 92.10%',
      
      title1: 'Reward Claiming:',
      text1_1: 'Rewards can be claimed once every 24 hours',
      text1_2: 'If no DLC is initially staked or the amount staked is less than 10,000, the earnings will accumulate as staked DLC until reaching 10,000 DLC',
      text1_3: '1) Rent will accumulate as staked capital until reaching 10,000 DLC',
      text1_4: '2) The minimum rental period is 2 hours, with no maximum rental time limit; when less than 1 hour of usable duration remains, the machine cannot be rented and is not counted towards online rewards. Miners can extend the duration at any time, but each extension must be at least 2 hours',
      text1_5: 'Rewards can be withdrawn at any time. Each time you withdraw, 10% of the newly generated rewards can be withdrawn immediately, while 90% are locked for 180 days. The locked portion can be withdrawn at a rate of 0.5% per withdrawal, and the full amount can be withdrawn after 180 days',
      
      title2: 'Daily DLC Earnings Calculation for Machines: DLC is calculated at a price of {num}U,',
      text2_1: "My CPU machine's bandwidth:",
      text2_2: 'Number of node NFTs:',
      text2_3: 'Region:',
      text2_4: 'Amount of staked DLC:',
      text2_5: 'Total bandwidth:',
      text2_6: '(Assuming an average of 10 NFTs, and an average staking of 10,000 DLC for calculation)',
      text2_7: 'Please select',
      title3: 'On-chain reward income: {dlc_num} DLC (equivalent to {usdt_num} USD at the current DLC price: {num} USD)',
      title4: "Reporting and Verification Mechanism (Based on DBC AI public chain's EVM-compatible DLC)",
      text4_1: 'The machine permanently has a DBC AI public chain detection mechanism, reporting information to the DBC distributed detection cluster to determine if the machine is online; if it is not online, online rewards are deducted. If a disruption occurs during user use, DLC is deducted from the user. Penalty limit:',
      text4_2: '1) If no coins are staked, only accumulated rewards are penalized, up to 10,000 DLC',
      text4_3: '2) If DLC is staked, up to 10,000 DLC can be penalized',
    }
  },
  coverage: {
    title: 'DeepLink software  global user distribution map',
    text: 'Total number of DeepLink users:'
  },
  "bandwidthDataMiningArea": "Mining Area",
  "bandwidthDataMachineCount": "Machine Count",
  "bandwidthDataBandwidthAmount": "Bandwidth Amount",
  "bandwidthDataDailyMiningOutput": "Daily Mining Output",
  "cumulativeBurnAmount": "Cumulative Burn Amount",
  "bandwidthDataDLCStakeAmount": "DLC Stake Amount",
  "bandwidthDataCurrentMiningMachineCount": "Current Total Mining Machine Count",
  "miningRules": "Mining Rules",
  "dataDisplay": "Data Display",
  "cumulativeBurnAmount": "Cumulative Burn Amount",
  page404: {
    title: 'DeepLink Protocol',
    text: 'Decentralized AI Cloud Gaming Protocol',
    text1: 'The page you are trying to access has encountered an issue. Please return to the homepage',
    btn: 'GO Home'
  },
  paypal: {
    title: 'Pay with PayPal',
    step_text1: 'Choose amount',
    step_text2: 'Pay with PayPal',
    step_text3: 'Payment result',
    step1: {
      text1: 'Please select the purchase amount',
      text2: '(An 8% transaction fee will be charged)',
      label1: 'Buyer Wallet:',
      label2: 'DLC Purchase Amount:',
      tip1: 'Please enter the purchase amount:',
      tip2: 'Must be a number',
      tip3: 'Minimum purchase is { Min_Num } DLC ≈ 10 USD, maximum is { Max_Num } DLC ≈ 100 USD',
      label3: 'Equivalent USD:',
      label4: 'Transaction Fee:',
      label5: 'Total:',
      btn1: 'Confirm',
      btn2: 'Cancel'
    },
    step1_paypal: {
      tip3: 'Minimum purchase is { Min_Num } points ≈ 10 USD, maximum is { Max_Num } points ≈ 100 USD',
    },
    step2: {
      text1: 'Loading PayPal...',
      text2: 'Retry',
      text3: 'User cancelled the payment'
    },
    step3: {
      text1: 'Purchase record',
      text2: 'Purchase wallet:',
      text3: 'Purchase amount:',
      text4: 'Equivalent amount:',
      text5: 'Transaction fee:',
      text6: 'Transaction ID:',
      text7: 'Transaction status:',
      tip_text1: 'Querying payment, please wait...',
      tip_text2: 'Verification complete. Tokens will be transferred to your account within 10 minutes. Please check!',
      tip_text3: 'Transaction status error. Please contact the admin at: service{@}deeplink.cloud'
    },
    msg1: 'Payment completed, awaiting verification',
    msg2: 'Invalid wallet address',
    msg3: 'Zero address is not allowed',
    msg4: 'Valid address',
    msg5: 'Wallet address cannot be empty',
    msg6: 'Purchase amount cannot be 0',
    msg7: 'Invalid wallet address. Please check if it is correct'
  }
}